<template>
  <div class="hidden sm:block max-w-[280px] mt-[50px]">
    <div class="flex flex-col gap-2 ml-5">
      <router-link
        :to="{ name: 'UserInfoPage' }"
        :class="{ 'bg-gray-200': activeItem === 'accountInfo' }"
        class="cursor-pointer px-5 py-3 rounded-lg transition-colors ease-out duration-200 hover:bg-gray-200"
      >
        <div class="label">
          {{ $t('messages.menu.account_info') }}
        </div>
      </router-link>
      <router-link
        :class="{ 'bg-gray-200': activeItem === 'Passkey' }"
        :to="{ name: 'PasskeyPage' }"
        class="cursor-pointer px-5 py-3 rounded-lg transition-colors ease-out duration-200 hover:bg-gray-200"
      >
        <div class="label">
          {{ $t('messages.menu.passkey') }}
        </div>
      </router-link>
      <router-link
        v-if="user && user.login_method === 'password' && user.passwordless_status !== 'completed'"
        :to="{ name: 'TwoFactorAuthPage' }"
        :class="{ 'bg-gray-200': activeItem === 'two-factor-auth' }"
        class="cursor-pointer px-5 py-3 rounded-lg transition-colors ease-out duration-200 hover:bg-gray-200"
      >
        <div class="label">
          {{ $t('messages.menu.two_factor_auth') }}
        </div>
      </router-link>
      <router-link
        :class="{ 'bg-gray-200': activeItem === 'loginHistory' }"
        :to="{ name: 'UserLoginHistoryPage' }"
        class="cursor-pointer px-5 py-3 rounded-lg transition-colors ease-out duration-200 hover:bg-gray-200"
      >
        <div class="label">
          {{ $t('messages.menu.sign_in_history') }}
        </div>
      </router-link>
      <router-link
        :class="{ 'bg-gray-200': activeItem === 'notification' }"
        :to="{ name: 'UserNotificationPage' }"
        class="cursor-pointer px-5 py-3 rounded-lg transition-colors ease-out duration-200 hover:bg-gray-200"
      >
        <div class="label">
          {{ $t('messages.menu.notifications') }}
        </div>
      </router-link>
      <router-link
        :class="{ 'bg-gray-200': activeItem === 'subscription' }"
        :to="{ name: 'EmailSubscriptionPage' }"
        class="cursor-pointer px-5 py-3 rounded-lg transition-colors ease-out duration-200 hover:bg-gray-200"
      >
        <div class="label">
          {{ $t('messages.menu.subscriptions') }}
        </div>
      </router-link>
      <router-link
        v-if="isStaffVerified"
        :class="{ 'bg-gray-200': activeItem === 'management' }"
        :to="{ name: 'ManagementPage' }"
        class="cursor-pointer px-5 py-3 rounded-lg transition-colors ease-out duration-200 hover:bg-gray-200"
      >
        <div class="label">
          {{ $t('messages.menu.management') }}
        </div>
      </router-link>
      <router-link
        v-if="isStaffVerified"
        :class="{ 'bg-gray-200': activeItem === 'oauth-management' }"
        :to="{ name: 'OAuthManagementPage' }"
        class="cursor-pointer px-5 py-3 rounded-lg transition-colors ease-out duration-200 hover:bg-gray-200"
      >
        <div class="label">
          {{ $t('messages.menu.oauth_management') }}
        </div>
      </router-link>
      <router-link
        v-if="user && user.entra_id_eligible"
        :to="{ name: 'EntraIdConfigPage' }"
        :class="{ 'bg-gray-200': activeItem === 'entra' }"
        class="cursor-pointer px-5 py-3 rounded-lg transition-colors ease-out duration-200 hover:bg-gray-200"
      >
        <div class="label">
          {{ $t('messages.menu.entra') }}
        </div>
      </router-link>
    </div>
  </div>
</template>
<script>
import { useAuthStore } from '@/stores/auth';

export default {
    name: 'UserMenu',
    props: {
        user: Object,
        activeItem: String
    },
    computed: {
        isStaffVerified() {
            return useAuthStore().is_staff_verified;
        }
    },
}
</script>
